var render = function render(){
  var _vm$value;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "outlined": "",
      "rounded": "lg"
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--x-large",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "recruitment-item__detail mb-10 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('h5', {
    staticClass: "page-text--lg font-weight-medium mb-4"
  }, [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.title) + " ")]), _c('v-row', {
    staticClass: "row--small mb-4",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "applied-card__link",
    attrs: {
      "cols": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-6--text"
  }, [_vm._v("매칭URL: " + _vm._s(_vm.matchUrl))])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "icon": "",
      "small": "",
      "color": "grey"
    },
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.matchUrl);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-content-copy")])], 1)], 1)], 1), _c('meeting-list-item-matching', _vm._b({}, 'meeting-list-item-matching', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "9",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--large"
  }, [_c('v-col', {
    staticClass: "mb-4 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "auto"
    }
  }, [_c('meeting-list-item-state', _vm._g(_vm._b({}, 'meeting-list-item-state', {
    value: _vm.value
  }, false), {
    put: _vm.put
  }))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "auto"
    }
  }, [_c('meeting-list-item-counts', _vm._b({}, 'meeting-list-item-counts', {
    value: _vm.value
  }, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "auto"
    }
  }, [_c('meeting-view', _vm._b({
    on: {
      "input": function (value) {
        return _vm.$emit('input', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-lg-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey-6--text"
        }, [_vm._v("미팅정보 수정")])])];
      }
    }])
  }, 'meeting-view', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12",
      "lg": "auto"
    }
  }, [_c('meeting-status', _vm._b({
    on: {
      "input": function (value) {
        return _vm.$emit('input', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-lg-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("미팅현황")])];
      }
    }])
  }, 'meeting-status', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "auto"
    }
  }, [_c('texting-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-lg-100px",
          attrs: {
            "outlined": "",
            "small": "",
            "block": "",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v("문자발송")])])];
      }
    }])
  }, 'texting-dialog', _vm.textingProps, false))], 1)], 1)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }